import {Grid} from '@yandex-delivery/blocks'
import type {FC} from 'react'
import {useEffect, useRef} from 'react'
import {useController, useFormContext} from 'react-hook-form'

import {store} from '../../store'
import type {SharingProvider} from '../../types'
import type {VerticalsWidgetProps as Props} from '../types'
import {VerticalItem} from './VerticalItem/VerticalItem'
import * as classes from './Verticals.classes'

export const VerticalsWidget: FC<Props> = props => {
  const {options, form_state_key} = props.config
  const {control, watch, setValue} = useFormContext()
  const rootRef = useRef<HTMLDivElement | null>(null)

  // дефолтная вертикаль - первая в списке
  const defaultValue = options.length !== 0 ? options[0].value : undefined
  const {field} = useController({name: form_state_key, control, defaultValue})

  useEffect(() => {
    const currentVertical = options.find(itemProps => itemProps.value === field.value)
    const defaultStateValues = currentVertical?.default_values

    // устанавливаем familiar_vertical_id если вертикаль есть в списке
    // если ее нет - переключаемся на familiar_vertical_id или на первую вертикаль в списке
    if (currentVertical) {
      setValue('familiar_vertical_id', currentVertical.familiar_vertical_id)
      if (defaultStateValues) {
        // если с вертикалью пришли какие-то дефолты, добавляем их в стейт
        Object.keys(defaultStateValues).forEach(key => {
          setValue(key, defaultStateValues[key])
        })
        if (defaultStateValues.sharing_provider) {
          store.state.sharingProvider = defaultStateValues.sharing_provider as SharingProvider
        }
      }
    } else {
      const familiarVerticalName = watch('familiar_vertical_id')
      const familiarVertical = options.find(itemProps => itemProps.value === familiarVerticalName)
      if (familiarVertical) {
        setValue(form_state_key, familiarVertical.value)
      } else setValue(form_state_key, defaultValue)
    }
  }, [watch, setValue, field.value, defaultValue, options, form_state_key])

  return (
    <Grid xs={12} item>
      <div ref={rootRef} className={classes.wrapper.verticals}>
        {options.length !== 0
          ? options.map((itemProps, i) => (
              <div key={i} className={classes.wrapper.verticalItem}>
                <VerticalItem
                  active={field.value === itemProps.value}
                  onClick={field.onChange}
                  rootRef={rootRef}
                  tag={itemProps.value === 'walking_courier' ? 'New!' : undefined}
                  {...itemProps}
                />
              </div>
            ))
          : null}
      </div>
    </Grid>
  )
}
